
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Localtaxiserviceinpune() {



    const cardData =
    {
        keyword: 'Local Taxi Service in Pune',
        heading: 'Meghana Cab : Local Taxi Service in Pune',
        headingDescription: 'Meghana Cab offers Local Taxi Service in Pune, providing fast, reliable, and affordable rides across the city. Whether you need a quick trip to the airport, a ride to a business meeting, or a comfortable journey around town, our clean cars and professional drivers ensure a hassle-free experience. Enjoy easy booking, transparent fares, and 24/7 availability—perfect for daily commutes or spontaneous plans. Book your local taxi in Pune with Meghana Cab and ride with convenience, safety, and peace of mind.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic 18th-century fortification that once served as the seat of the Peshwas of the Maratha Empire. Built in 1732, the fort is famous for its grand Delhi Gate, majestic ruins, and the haunting stories that surround it. The evening light and sound show brings to life the rich Maratha history, making it a cultural and educational destination ideal for tourists, students, and history buffs."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace holds deep significance in India’s freedom movement. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other national leaders during the Quit India Movement. The palace features Italian arches, spacious lawns, and a museum with rare photographs and personal belongings of the Gandhis. It’s a peaceful retreat and a must-visit for those interested in India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri ranges around 30 km from Pune, Sinhagad Fort is a popular trekking and weekend destination. The fort is historically linked to the valor of Tanaji Malusare, a Maratha warrior. With panoramic views, cool breeze, and local snacks like kanda bhaji and curd served at the top, Sinhagad offers a blend of adventure, history, and local flavor."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a rock-cut 8th-century shrine dedicated to Lord Shiva. Located in the heart of Pune, this architectural marvel is carved out of a single basalt rock and features intricately designed pillars and a circular Nandi mandapa. Its serene environment and spiritual aura attract both pilgrims and history enthusiasts alike."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This fascinating museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar in memory of his son. The collection includes musical instruments, Mughal-era artifacts, ancient weaponry, and everyday items used by royal families. The museum gives visitors a unique glimpse into India’s rich artistic and cultural heritage."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Inspired by the famous Okayama Korakuen Garden in Japan, this sprawling green space is a tranquil escape within Pune city. It features beautifully landscaped lawns, waterfalls, small bridges, and seasonal blooms. Named after Marathi writer Pu La Deshpande, it's ideal for leisurely walks, photography, and nature appreciation."
  },
  {
    "title": "Rajiv Gandhi Zoological Park",
    "description": "Located near Katraj, this expansive zoo is divided into an animal orphanage, a snake park, and a traditional zoo section. Home to leopards, tigers, elephants, and a wide variety of snakes including the king cobra, it's an educational and entertaining destination for families and school groups."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage structures in Pune and offers a panoramic view of the city. It houses a complex of temples including those dedicated to Parvati, Kartikeya, Vishnu, and Shiva. The climb of over 100 steps is well worth it for the spiritual atmosphere and the scenic beauty it offers."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic spot located just outside Pune and serves as a popular picnic destination. Built on the Mutha River, it’s surrounded by hills and greenery and is a great place to enjoy sunsets, local food stalls, and peaceful walks along the water. It's also a gateway to other attractions like Sinhagad Fort and Panshet Dam."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in the upscale Koregaon Park, the Osho Ashram is a world-renowned meditation retreat attracting visitors from across the globe. The center offers spiritual healing, meditation sessions, and luxurious stays amid lush bamboo gardens. Whether you’re a seeker or simply looking for inner peace, this serene destination offers a unique and transformative experience."
  }
],

"services": [
    {
        "name": "Local Cab Booking Pune",
        "description": "Book reliable and affordable local cabs in Pune with Meghana Cab. Our fleet of well-maintained vehicles and professional drivers ensure timely and comfortable travel within the city."
    },
    {
        "name": "City Taxi Pune",
        "description": "Get around Pune city easily with Meghana Cab’s city taxi services. Whether for daily commute or quick errands, enjoy hassle-free rides with our efficient taxi service."
    },
    {
        "name": "Affordable Local Cabs Pune",
        "description": "Looking for budget-friendly local cab options in Pune? Meghana Cab offers economical rates without compromising on comfort or safety."
    },
    {
        "name": "Taxi for Local Travel Pune",
        "description": "Travel across Pune locally with Meghana Cab’s convenient taxi service, ideal for office trips, shopping, or city tours with trusted drivers."
    },
    {
        "name": "Pune City Ride Service",
        "description": "Experience smooth and safe rides across Pune city with Meghana Cab’s city ride service, offering punctual pickups and professional drivers."
    },
    {
        "name": "Pune Local Car Rentals",
        "description": "Rent cars locally in Pune with Meghana Cab, available in various vehicle types to suit your travel needs for short or extended periods."
    },
    {
        "name": "Hourly Taxi in Pune",
        "description": "Book hourly taxi services in Pune with Meghana Cab for flexible and cost-effective local travel. Perfect for meetings, errands, or sightseeing within the city."
    },
    {
        "name": "Quick Local Taxi Hire Pune",
        "description": "Need a fast local taxi in Pune? Meghana Cab provides quick booking options for immediate travel needs, ensuring no waiting time."
    },
    {
        "name": "AC Cab for Local Travel Pune",
        "description": "Stay cool and comfortable while traveling locally in Pune with Meghana Cab’s air-conditioned taxis, perfect for hot weather commutes."
    },
    {
        "name": "Local Sedan & SUV Cabs Pune",
        "description": "Choose from a wide range of sedans and SUVs for your local Pune travel. Meghana Cab offers spacious and comfortable vehicles for individuals and groups."
    },
    {
        "name": "Local Chauffeur Cabs Pune",
        "description": "Hire local chauffeur-driven cabs in Pune for professional, courteous, and safe transportation across the city."
    },
    {
        "name": "Local Airport Drop Taxi Pune",
        "description": "Book reliable airport drop services within Pune with Meghana Cab. Ensure timely arrivals and comfortable rides to Pune Airport."
    },
    {
        "name": "Short Distance Cabs in Pune",
        "description": "For short distance travel in Pune, Meghana Cab provides affordable and efficient cab services to meet your quick commute needs."
    },
    {
        "name": "Local Travel Cab Pune with Driver",
        "description": "Hire local cabs with experienced drivers in Pune who know the city well, ensuring a smooth and hassle-free travel experience."
    },
    {
        "name": "Book Local Ride in Pune",
        "description": "Easily book local rides in Pune with Meghana Cab’s user-friendly booking platform and enjoy safe, prompt transportation anywhere in the city."
    }
],

"tableData": [
    ["Local Cab Booking Pune", "City Taxi Pune"],
    ["Affordable Local Cabs Pune", "Taxi for Local Travel Pune"],
    ["Pune City Ride Service", "Pune Local Car Rentals"],
    ["Hourly Taxi in Pune", "Quick Local Taxi Hire Pune"],
    ["AC Cab for Local Travel Pune", "Local Sedan & SUV Cabs Pune"],
    ["Local Chauffeur Cabs Pune", "Local Airport Drop Taxi Pune"],
    ["Short Distance Cabs in Pune", "Local Travel Cab Pune with Driver"],
    ["Book Local Ride in Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Local Taxi Service in Pune",
        "WhyChoosedescription": "Meghana Cab offers trusted and reliable local taxi service in Pune for daily commutes, errands, meetings, shopping, and more. Enjoy smooth and dependable rides within the city at your convenience."
    },
    {
        "WhyChooseheading": "Timely and Efficient City Travel",
        "WhyChoosedescription": "Our local taxi service ensures on-time pick-ups and drop-offs, so whether you’re heading to work or catching a train, you’ll always be on schedule with Meghana Cab."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are experienced, polite, and familiar with every corner of Pune. They ensure safe, comfortable, and efficient rides, whether you're heading across town or to a nearby suburb."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fare Structure",
        "WhyChoosedescription": "We provide clear, competitive pricing with no hidden charges. With Meghana Cab’s local taxi service in Pune, you get great value and peace of mind on every ride."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All our taxis are regularly cleaned and sanitized. Travel in comfort and safety with vehicles equipped with air conditioning, seat belts, and GPS tracking."
    },
    {
        "WhyChooseheading": "24/7 Local Taxi Availability in Pune",
        "WhyChoosedescription": "Need a ride late at night or early in the morning? Meghana Cab offers round-the-clock local taxi services, ensuring you have a ride whenever you need it."
    },
    {
        "WhyChooseheading": "Flexible Hourly and Point-to-Point Rides",
        "WhyChoosedescription": "Whether you need a taxi for a few hours or just a one-way trip, Meghana Cab offers flexible options to suit your schedule and local travel needs in Pune."
    },
    {
        "WhyChooseheading": "Simple Online Booking and Quick Support",
        "WhyChoosedescription": "Booking your local taxi in Pune is quick and easy through our app or website. For any queries or assistance, our customer support team is always ready to help."
    }
]






















    }

const faqData = [
    {
        question: "How can I book a local taxi service in Pune with Meghana Cab?",
        answer: "You can easily book a local taxi in Pune through Meghana Cab’s website or by calling us directly at +91 9075462128."
    },
    {
        question: "What types of vehicles are available for local taxi service in Pune?",
        answer: "We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit your local travel needs."
    },
    {
        question: "Can I book a taxi for hourly local trips in Pune?",
        answer: "Yes, Meghana Cab offers flexible hourly local taxi services within Pune city to fit your schedule."
    },
    {
        question: "Are Meghana Cab drivers experienced with Pune local routes?",
        answer: "Absolutely! Our drivers are well-acquainted with Pune’s local routes and traffic patterns to ensure timely and safe travel."
    },
    {
        question: "Is the local taxi service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab operates 24/7 for local taxi bookings in Pune, so you can book anytime."
    },
    {
        question: "What are the payment options for local taxi service in Pune?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "Can I request multiple stops during a local taxi trip in Pune?",
        answer: "Yes, you can request multiple stops. Please inform us while booking so we can plan your trip accordingly."
    },
    {
        question: "Are tolls and parking charges included in the local taxi fare?",
        answer: "Tolls and parking charges, if any, are additional and communicated during the booking."
    },
    {
        question: "Is Meghana Cab’s local taxi service safe for families and solo travelers?",
        answer: "Yes, we prioritize safety and provide professional drivers to ensure a secure and comfortable journey."
    },
    {
        question: "How can I contact Meghana Cab for local taxi service in Pune?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support anytime."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ashok Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I regularly use Meghana Cab for local taxi services in Pune. The drivers are punctual, and the vehicles are always clean and comfortable.”',
    },
    {
        name: 'Ms. Priya Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab’s local taxi service in Pune is reliable and affordable. Booking is easy, and the drivers are friendly and knowledgeable about the city.”',
    },
];

















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Local Taxi Service in Pune",
  "image": "https://www.meghanacabs.com/assets/images/local-taxi-service-pune.jpg",
  "description": "Book local taxi service in Pune with Meghana Cabs. Affordable and reliable cabs for city travel, airport drop, hourly rentals, and quick local rides with AC Sedan and SUV options.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5253"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/local-taxi-service-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>Local Taxi Service in Pune | Affordable & Reliable | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book local taxi service in Pune with Meghana Cabs. Affordable and reliable cabs for city travel, airport drop, hourly rentals, and quick local rides with AC Sedan and SUV options." 
  />
  <meta 
    name="keywords" 
    content="Local Cab Booking Pune, City Taxi Pune, Affordable Local Cabs Pune, Taxi for Local Travel Pune, Pune City Ride Service, Pune Local Car Rentals, Hourly Taxi in Pune, Quick Local Taxi Hire Pune, AC Cab for Local Travel Pune, Local Sedan & SUV Cabs Pune, Local Chauffeur Cabs Pune, Local Airport Drop Taxi Pune, Short Distance Cabs in Pune, Local Travel Cab Pune with Driver, Book Local Ride in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Localtaxiserviceinpune;